import React from 'react';
import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';

import { AnchorLink } from '../Common';
import { colors, sidebarBreakpoint } from '../variables';

const ListItem = styled.li`
	display: block;
	margin: 0;
	padding: 0;

	${props =>
		props.hideOnLarge &&
		`
		@media (min-width: ${sidebarBreakpoint + 'px'}) {
			display: none;
		}
	`};
`;

const linkBaseStyles = css`
	display: block;
	text-decoration: none;
	padding: 16px 16px 16px 42px;
	background: transparent;
	font-weight: 400;
	font-size: 10px;

	&:after {
		content: '';
		display: block;
		clear: both;
	}

	&.active {
		background: ${colors.yellow.bromma};
	}

	&:hover,
	&:focus {
		background: ${colors.yellow.bromma};
	}
`;

const InternalLink = styled(NavLink)`
	${linkBaseStyles};
`;

const ExternalLink = styled(AnchorLink)`
	${linkBaseStyles};
	&:focus {
		background: transparent;
	}
`;

// Icons removed in redesign

const Name = styled.h3`
	text-transform: uppercase;
	color: #000;
	font-size: 12px;
	margin: 0;
	font-weight: 400;
`;

class SidebarItem extends React.Component {
	render() {
		const { name, hideOnLarge, external, to, ...rest } = this.props;

		// Get link of type depending on if link is external
		const Link = external ? ExternalLink : InternalLink;

		// Return the to prop as href or to depending on external or internal
		// because the react router uses to and "standard" anchor links use href
		const targetProps = external
			? { href: to, rel: 'noopener noreferrer', target: '_blank' }
			: { to };

		return (
			<ListItem hideOnLarge={hideOnLarge}>
				<Link {...rest} {...targetProps}>
					<Name>{name}</Name>
				</Link>
			</ListItem>
		);
	}
}

export default SidebarItem;



// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarItem.js